export interface CheckboxOptions {
    [key: string]: boolean
}

export interface TextFieldNumberOptions {
    value: number | null
}

export type RuleOptions = CheckboxOptions | TextFieldNumberOptions

export enum RuleType {
    DOWBlocked = "DOWBlocked",
    HoursBlocked = "HoursBlocked",
    MaxRechargeDurationOptions = "MaxRechargeDurationOptions",
    MaxRechargeEnergyOptions = "MaxRechargeEnergyOptions",
}

export enum IsActive {
    TRUE = "true",
    FALSE = "false",
    COMPANY = "company",
}

export interface Rule {
    type: RuleType;
    kind: "checkbox" | "number";
    isActive: IsActive;
    options?: Record<string, boolean> | null;
    defaultOptions?: Record<string, boolean>;
    value?: number | null;
    defaultValue?: number | null;
}

export type BackendSchema = {
    rules: {
        [RuleType.DOWBlocked]: CheckboxOptions | null
        [RuleType.HoursBlocked]: CheckboxOptions | null
        [RuleType.MaxRechargeEnergyOptions]: { value: number | null } | null
        [RuleType.MaxRechargeDurationOptions]: { value: number | null } | null
    }
}

export type RuleSchemaType = {
    [RuleType.DOWBlocked]: CheckboxOptions ;
    [RuleType.HoursBlocked]: CheckboxOptions;
    [RuleType.MaxRechargeDurationOptions]: TextFieldNumberOptions;
    [RuleType.MaxRechargeEnergyOptions]: TextFieldNumberOptions;
};

export const daysOfWeek = [
    "monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"
] as const;

export const hourRanges = [
    "00h-02h", "02h-04h", "04h-06h", "06h-08h", "08h-10h", "10h-12h",
    "12h-14h", "14h-16h", "16h-18h", "18h-20h", "20h-22h", "22h-24h"
] as const;

export function createCheckboxOptions(keys: readonly string[], value: boolean): CheckboxOptions {
    return Object.fromEntries(keys.map(key => [key, value]));
}

export function createTextFieldOption(value: number | null): TextFieldNumberOptions {
    return { value };
}

export const GetRuleCompany: RuleSchemaType = {
    [RuleType.DOWBlocked]: createCheckboxOptions(daysOfWeek, true),
    [RuleType.HoursBlocked]: createCheckboxOptions(hourRanges, true),
    [RuleType.MaxRechargeDurationOptions]: createTextFieldOption(1),
    [RuleType.MaxRechargeEnergyOptions]: createTextFieldOption(1),
};

export const RuleSchema: RuleSchemaType = {
    [RuleType.DOWBlocked]: createCheckboxOptions(daysOfWeek, false),
    [RuleType.HoursBlocked]: createCheckboxOptions(hourRanges, false),
    [RuleType.MaxRechargeDurationOptions]: createTextFieldOption(null),
    [RuleType.MaxRechargeEnergyOptions]: createTextFieldOption(null),
};
